<template>
<div class="chapter">
<div class="inner_page">
<h1 class="chapter" id="c11"><a id="page12"></a>Ring in the Holidays</h1>
<p class="nonindent"><span class="dropcaps">B</span>eing the very model of a modern mature woman, Janne Grim decided she would propose to her boyfriend as opposed to the traditional vice-versa. The young Norwegian woman invited her boyfriend Svein Froeytland to a Christmas party and hid the wedding ring in his porridge. She watched impatiently as he wolfed down the porridge but when he didn’t mention the ring she took that as a “no.” After swallowing her pride, Janne told Svein about the proposed proposal, and he told her he must have swallowed the ring. He accepted her proposal and, borrowing a ring from one of the guests, made the engagement official. Svein said, “Now that I am twenty-four karats heavier, I will have to wait for nature to take its course. Then the ring will take its course, and everything will work out in the end.”<img alt="" src="OEBPS/images/Greg_9780740792069_epub_L04_r1.jpg"/></p>
<div class="textbox">
<p class="center"><img alt="" src="OEBPS/images/Greg_9780740792069_epub_L05_r1.jpg"/></p>
<p class="center"><strong>CHICK ACCUSES SOME OF HER<br/>MALE COLLEAGUES OF SEXISM</strong></p>
<p class="center"><img alt="" src="OEBPS/images/Greg_9780740792069_epub_L06_r1.jpg"/></p>
<p class="center"><span class="small">Article concerning allegations of sexism<br/>from then-councilwoman, now Los Angeles City Controller Laura Chick.<br/>— <em>The Los Angeles Times,</em> June 23, 1998</span></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 9780740792069_epub_c11_r1.vue?4d7f8a18